var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{staticClass:"subtle cursor-pointer",class:_vm.backgroundColor || ''},[_c('td',{staticClass:"w-full p-0"},[_c('offer-card',{attrs:{"offer":_vm.item}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }